import { put, takeLatest, select, all } from "redux-saga/effects";
import { SEND_DROPOFF_AUTHORIZATION_REQUEST } from "../actions/dropOffAuthorize";
import { log } from "../../utils/loggger";
import { CONTINUE } from "../../constants";

import { sendProspectRequest } from "../actions/sendProspectToAPI";
import { getProspect } from "../selectors/appConfig";

export function* dropOffAuthorizationSaga() {
  try {
    const prospect = yield select(getProspect);
    const newProspect = {
      ...prospect,
      applicationInfo: {
        ...prospect.applicationInfo,
        dropoffAuthorize: true
      }
    };
    yield put(sendProspectRequest(newProspect, CONTINUE));
  } catch (e) {
    log(e);
  }
}

export default function* dropOffAuthorizeSagas() {
  yield all([takeLatest(SEND_DROPOFF_AUTHORIZATION_REQUEST, dropOffAuthorizationSaga)]);
}
